var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { useTheme } from 'styled-components';
import { getMarkdownPreStyle, markdownCodeStyle, markdownLinkProps, MarkdownWrapper, } from './styles';
export const AssistantMarkdown = ({ children, }) => {
    const theme = useTheme();
    return (_jsx(MarkdownWrapper, { children: _jsx(ReactMarkdown, { remarkPlugins: [remarkGfm], skipHtml: true, components: {
                pre(_a) {
                    var { children: preChildren } = _a, props = __rest(_a, ["children"]);
                    return (_jsx("pre", Object.assign({ style: getMarkdownPreStyle(theme) }, props, { children: preChildren })));
                },
                code(_a) {
                    var { children: codeChildren } = _a, props = __rest(_a, ["children"]);
                    return (_jsx("code", Object.assign({ style: markdownCodeStyle }, props, { children: codeChildren })));
                },
                a(_a) {
                    var props = __rest(_a, []);
                    return _jsx("a", Object.assign({}, markdownLinkProps, props));
                },
            }, children: children }) }));
};
export default AssistantMarkdown;
